import * as React from 'react'
import { Icons, Typography } from '@lacedltd/laced-components'
import { useLocale, useTranslation } from 'hooks'
import { withTranslations } from 'helpers'
import * as S from './ExpandedMobileNav.styles'
import type { ShopNavBrand } from '../../TopNav.types'

const ExpandedMobileNav: React.FC<ExpandedMobileNavProps> = ({
  handleClick,
  setShowMore,
  selectedBrand,
  displayedBrands
}) => {
  const { t } = useTranslation()
  const { localiseUrl } = useLocale()
  const { title: brandTitle, subcategories } = selectedBrand || {}

  let title

  if (selectedBrand) {
    title = brandTitle
  } else {
    title = t('react_components.top_nav.more_brands')
  }

  return (
    <>
      <S.BackButton
        fullWidth
        variant="tertiary"
        onClick={() =>
          selectedBrand ? handleClick(undefined) : setShowMore(false)
        }
      >
        <Icons.Left size="m" />{' '}
        <Typography.Text variant="body" color="airJordan.p">
          {title}
        </Typography.Text>
      </S.BackButton>

      <S.ContentSection>
        {selectedBrand ? (
          <>
            <S.NavLink size="l" href={localiseUrl(selectedBrand.url)} underline>
              <Typography.Text variant="body" color="airJordan.600">
                {t('react_components.top_nav.view_all', {
                  brand: brandTitle
                })}
              </Typography.Text>
            </S.NavLink>

            <S.Grid>
              {subcategories?.map((subcategory, i) => (
                <li key={i}>
                  <S.NavLink size="l" href={localiseUrl(subcategory.url)}>
                    <Typography.Text variant="body" color="airJordan.600">
                      {subcategory.plp}
                    </Typography.Text>
                  </S.NavLink>
                </li>
              ))}
            </S.Grid>
          </>
        ) : (
          <>
            {displayedBrands.map((displayedBrand, i) => (
              <S.MobileNavButton
                fullWidth
                key={i}
                variant="tertiary"
                onClick={() => handleClick(displayedBrand)}
              >
                <Typography.Text variant="body">
                  {displayedBrand.title}
                </Typography.Text>{' '}
                <Icons.Right size="m" />
              </S.MobileNavButton>
            ))}
          </>
        )}
      </S.ContentSection>
    </>
  )
}

interface ExpandedMobileNavProps {
  selectedBrand?: ShopNavBrand
  displayedBrands: ShopNavBrand[]
  handleClick: (brand: ShopNavBrand | undefined) => void
  setShowMore: (arg: boolean) => void
}
export default withTranslations(ExpandedMobileNav)
